import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
import { setWindowLocationHref } from 'hs-browser-apis/location';

export function navigateToWorkspace(
  workspaceId: number | string,
  queryParams?: Record<string, string>
) {
  const workspaceUrl = getWorkspaceUrl(workspaceId);
  const params = new URLSearchParams(queryParams);
  const query = params.toString();
  const href = query ? `${workspaceUrl}?${query}` : workspaceUrl;

  setWindowLocationHref(href);
}

export function getWorkspaceUrl(workspaceId: number | string) {
  return `${getFullUrl(
    'app'
  )}/breeze-builder/${PortalIdParser.get()}/edit/${workspaceId}`;
}

export function getHomepageUrl() {
  return `${getFullUrl('app')}/breeze-builder/${PortalIdParser.get()}`;
}
